import React, { useState } from 'react';
import { LocalizationProvider } from '@mui/x-date-pickers';
import { useNavigate } from 'react-router-dom';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { useSelector } from 'react-redux';
import { format, addDays } from 'date-fns';
import { FlexContainer } from '@/components/containers/FlexContainer/FlexContainer';
import { COWORKING, MEETING_ROOM } from '@/types/spaceTypes.constants';
import {
  calculateHoursDifference,
  formatTime12h,
  formatDateEnCard,
  formatDateEsCard,
} from '@/helpers/dateHelpers';
import dayjs from 'dayjs';

require('dayjs/locale/es');
dayjs.locale('es');

const GuestDataForm = props => {
  const navigate = useNavigate();
  const { onSubmitFunction, spaceDetail, lenguage, backButton } = props;
  const searchFormData = useSelector(state => state.searchFormData);
  const tomorrow = format(addDays(new Date(), 1), 'yyyy-MM-dd');

  const values = {
    startDate: searchFormData?.startDate ? searchFormData?.startDate : tomorrow,
    startTime: searchFormData?.startTime ? searchFormData?.startTime : '09:00',
    endTime: searchFormData?.endTime ? searchFormData?.endTime : '10:00',
    guestQuantyty: searchFormData?.guests ? searchFormData?.guests : 1,
    spaceType: spaceDetail?.subtype_id,
    name: '',
    email: '',
    phone: '',
    countryCode: lenguage === 'EN' ? '+1' : '+52',
  };

  const handleSelectCard = () => {
    navigate('/payment-card-selector');
  };

  const handleSelectGuest = () => {
    navigate('/guestselected');
  };

  const handleSetDateTime = () => {
    navigate('/reservation-date');
  };

  const hours = calculateHoursDifference(values?.startTime, values?.endTime);

  const totalPrice = () => {
    const price = parseFloat(spaceDetail?.calculatedPrice || '0');
    let total;
    if (spaceDetail?.subtype_id === COWORKING) {
      total = price * (values?.guestQuantyty || 1);
    } else {
      total = price * (hours > 0 ? hours : 0);
    }
    return parseFloat(total.toFixed(2));
  };

  const dayLabel = lenguage === 'EN' ? ' day' : ' día';
  const hourLabel = lenguage === 'EN' ? ' hour' : ' hora';
  const timeLabel =
    spaceDetail?.subtype_id === COWORKING ? dayLabel : hourLabel;
  const peopleLabelEn = values?.guestQuantyty === 1 ? ' Person' : ' People';
  const peopleLabelEs = values?.guestQuantyty === 1 ? ' Persona' : ' Personas';
  const guestLabel =
    lenguage === 'EN'
      ? 'Guest ' + values?.guestQuantyty + peopleLabelEn
      : 'Invitados ' + values?.guestQuantyty + ' ' + peopleLabelEs;

  const startTime =
    lenguage === 'EN'
      ? formatDateEnCard(values?.startDate) + ' ' + values?.startTime
      : formatDateEsCard(values?.startDate) + ' ' + values?.startTime;

  const endTime =
    lenguage === 'EN'
      ? formatDateEnCard(values?.startDate) +
        ' ' +
        formatTime12h(values?.endTime)
      : formatDateEsCard(values?.startDate) +
        ' ' +
        formatTime12h(values?.endTime);

  return (
    <LocalizationProvider dateAdapter={AdapterDayjs}>
      <FlexContainer className={'gap-20 m-flex-column'}>
        <FlexContainer className={'flex-column gap-20 width100'}>
          <FlexContainer className={'flex-column gap-8'}>
            <FlexContainer
              className={
                'justify-between grayShadowBottom padlr20 padtb20 border-rad10px borderGray100'
              }
            >
              <label className={'text-16 '}>{guestLabel} </label>
              <button
                type="button"
                onClick={() => handleSelectGuest()}
                className={'bgTransparent fontWhite borderNone padtb4 text-12'}
              >
                <span className={'text-16 margr6'}>Required</span>
                <i className="fa fa-chevron-right" />
              </button>
            </FlexContainer>
            <FlexContainer
              className={
                'justify-between grayShadowBottom padlr20 padtb20 border-rad10px borderGray100'
              }
            >
              <label className={'text-16 '}>
                {' '}
                {lenguage === 'ES' ? 'Tipo de Espacio ' : 'Room Type '}
              </label>
              <button
                type="button"
                className={'bgTransparent fontWhite borderNone padtb4 text-12'}
              >
                {spaceDetail?.subtype_id === COWORKING && (
                  <span className={'text-16 margr6'}>
                    {' '}
                    {lenguage === 'ES'
                      ? 'Pase de coworking '
                      : 'Day Pass - Shared space '}
                  </span>
                )}
                {spaceDetail?.subtype_id === MEETING_ROOM && (
                  <span className={'text-16 margr6'}>
                    {' '}
                    {lenguage === 'ES' ? 'Sala de Juntas ' : 'Meeting Room '}
                  </span>
                )}
              </button>
            </FlexContainer>
            <FlexContainer
              className={
                'flex-column justify-between grayShadowBottom padlr20 padtb20 border-rad10px borderGray100 gap-20'
              }
            >
              <FlexContainer className={'justify-between'}>
                <label className={'text-16'}>Check - In </label>
                <button
                  type="button"
                  onClick={() => handleSetDateTime()}
                  className={
                    'bgTransparent fontWhite borderNone padtb4 text-12'
                  }
                >
                  <span className={'text-16'}> {startTime} </span>
                  <i className="fa fa-chevron-right" />
                </button>
              </FlexContainer>

              <FlexContainer className={'justify-between'}>
                <label className={'text-16'}>Check - Out</label>
                <button
                  type="button"
                  onClick={() => handleSetDateTime()}
                  className={
                    'bgTransparent fontWhite borderNone padtb4 text-12'
                  }
                >
                  <span className={'text-16'}> {endTime} </span>
                  <i className="fa fa-chevron-right" />
                </button>
              </FlexContainer>
            </FlexContainer>

            <FlexContainer
              className={
                'flex-column justify-between grayShadowBottom padlr20 padt20 border-rad10px borderGray100 GAP-10'
              }
            >
              <FlexContainer className={'justify-between gap-20'}>
                <label className={'text-16 m-text-14 '}>
                  {' '}
                  {lenguage === 'ES' ? 'Precio por ' : 'Price per '} {timeLabel}
                  :
                </label>
                <label className={'text-16 m-text-14 '}>
                  <strong>${spaceDetail?.formattedPrice} </strong>
                </label>
              </FlexContainer>
              {spaceDetail?.subtype_id !== 1 && (
                <FlexContainer
                  className={'justify-between borderBottom1 padb10'}
                >
                  <label className={'text-16 m-text-14 '}>
                    {' '}
                    {lenguage === 'ES' ? 'Tiempo:' : 'Time'}
                  </label>
                  {lenguage === 'EN' && (
                    <label className={'text-16 m-text-14 '}>
                      <strong>
                        {hours}
                        {hours === 1 ? ' hour' : ' hours'}{' '}
                      </strong>
                    </label>
                  )}
                  {lenguage === 'ES' && (
                    <label className={'text-16 m-text-14 '}>
                      <strong>
                        {hours}
                        {hours === 1 ? ' hora' : ' horas'}{' '}
                      </strong>
                    </label>
                  )}
                </FlexContainer>
              )}
              {spaceDetail?.subtype_id === COWORKING && (
                <FlexContainer
                  className={'justify-between borderBottom1 padb10'}
                >
                  <label className={'text-16 m-text-14 '}>
                    {lenguage === 'ES'
                      ? 'Cantidad de personas:'
                      : 'Number of People:'}
                  </label>

                  <label className={'text-16 m-text-14 '}>
                    {values?.guestQuantyty > 1 && (
                      <strong>
                        {values?.guestQuantyty}
                        {lenguage === 'ES' ? ' personas' : ' seats'}{' '}
                      </strong>
                    )}
                    {values?.guestQuantyty == 1 && (
                      <strong>
                        {'x'}
                        {values?.guestQuantyty}
                        {lenguage === 'ES' ? ' persona' : ' seat'}{' '}
                      </strong>
                    )}
                  </label>
                </FlexContainer>
              )}
              <FlexContainer
                className={'justify-between justify-between padtb10'}
              >
                <label className={'text-16 m-text-14'}>
                  <strong>TOTAL</strong>
                </label>
                <label>
                  <strong className={'text-20 m-text-18'}>
                    ${totalPrice() + ' ' + spaceDetail?.currency}
                  </strong>
                </label>
              </FlexContainer>
            </FlexContainer>

            <FlexContainer
              className={
                'justify-between grayShadowBottom padlr20 padtb20 border-rad10px borderGray100'
              }
            >
              <label className={'text-16 '}>Payment Method </label>
              <button
                type="button"
                onClick={() => handleSelectCard()}
                className={'bgTransparent fontWhite borderNone padtb4 text-12'}
              >
                <span className={'text-16 margr6'}>Credit Card</span>
                <i className="fa fa-chevron-right" />
              </button>
            </FlexContainer>

            <FlexContainer
              className={
                'justify-between grayShadowBottom padlr20 padtb20 border-rad10px borderGray100'
              }
            >
              <label className={'text-16 '}>Promo Code </label>
              <button
                type="button"
                //onClick={() => setShowEditFormData(true)}
                className={'bgTransparent fontWhite borderNone padtb4 text-12'}
              >
                <span className={'text-16 margr6'}></span>
                <i className="fa fa-chevron-right" />
              </button>
            </FlexContainer>
            <FlexContainer
              className={
                'flex-column justify-between grayShadowBottom padlr20 padtb10 border-rad10px borderGray100'
              }
            >
              <label className={'text-16 margtb10'}>
                <strong>
                  {lenguage === 'ES' ? 'Necesitas Saberlo' : 'Need to Know'}
                </strong>
              </label>
              {spaceDetail?.subtype_id === COWORKING && (
                <FlexContainer className={'text-12'}>
                  {lenguage === 'ES'
                    ? 'El precio de renta de un pase de coworking no se calculará en función a la cantidad de horas seleccionadas, la reserva puede hacerse efectiva a lo largo del día seleccionado.'
                    : 'The rental price of a coworking pass will not be calculated based on the number of selected hours; the reservation can be used at any time throughout the selected day.'}
                </FlexContainer>
              )}
              {spaceDetail?.subtype_id !== 1 && (
                <FlexContainer className={'text-12'}>
                  {lenguage === 'ES'
                    ? 'El precio de renta de una sala de juntas o terraza se calculará en función a la cantidad de horas seleccionadas.'
                    : 'The rental price is calculated based on the number of hours selected.'}
                </FlexContainer>
              )}
            </FlexContainer>
          </FlexContainer>
        </FlexContainer>

        <FlexContainer
          className={
            'flex-column format100 m-formatAuto padtb10 border-rad10px'
          }
        >
          <FlexContainer
            className={
              'gap-8 text-12 align-center margt10 align-self-end m-hide'
            }
          >
            <button
              type="button"
              className={
                'bgTransparent padlr20 padtb6 fontWhite text-16 borderNone'
              }
              onClick={() => backButton()}
            >
              <i className={'fa fa-chevron-left margr6'} aria-hidden="true" />
              {lenguage === 'EN' ? 'Back' : 'Atrás'}
            </button>
          </FlexContainer>
          <FlexContainer className={'flex-column fontWhite'}>
            <button
              onClick={() => onSubmitFunction(spaceDetail, totalPrice())}
              className={
                'bgGradientPurple width100 border-rad8px borderGray050 fontWhite grayShadow16 margb30 padlr40 padtb10 text-18 pointer'
              }
            >
              <strong>
                {lenguage === 'ES' ? 'AGENDA AHORA' : 'BOOK NOW'}{' '}
              </strong>
            </button>
          </FlexContainer>
        </FlexContainer>
      </FlexContainer>
    </LocalizationProvider>
  );
};

const BookingView = props => {
  const { className, onSubmitFunction, spaceDetail, backButton } = props;
  const lenguage = useSelector(state => state.lenguage?.lang);
  const containerClass = className + ' flex-column';
  return (
    <FlexContainer className={containerClass}>
      <FlexContainer
        className={'gap-8 text-12 align-center margt30 align-self-start pointer'}
      >
        <button
          type="button"
          className={'bgTransparent padtb10 fontWhite text-14 borderNone'}
          onClick={() => backButton()}
        >
          <i
            className={'fa fa-chevron-left margr6 text-18'}
            aria-hidden="true"
          />
          {lenguage === 'EN'
            ? 'Back to space details'
            : 'Volver a detalles de espacio'}
        </button>
      </FlexContainer>
      <GuestDataForm
        onSubmitFunction={onSubmitFunction}
        spaceDetail={spaceDetail}
        lenguage={lenguage}
        backButton={backButton}
      />
    </FlexContainer>
  );
};

export default BookingView;
